// traceLogReducer.js
import axios, { safePostWithProgress } from '../../axios-default';
// Action types
const ADD_TRACE_LOG = 'ADD_TRACE_LOG';

// Initial state
const initialState = {
    traceLogs: [],
};

// Reducer
const traceLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TRACE_LOG:
            return {
                ...state,
                traceLogs: [...state.traceLogs, action.payload],
            };
        default:
            return state;
    }
};

// Action creators
const addTraceLog = (traceLog) => ({
    type: ADD_TRACE_LOG,
    payload: traceLog,
});

// Thunk action creator for making the AJAX call
const postTraceLog = (traceLogData) => {
    return async (dispatch) => {
        try {
            const response = await axios.post('case/traceLog', traceLogData);
            console.log('Add TraceLog Server:', response.data);
            dispatch(addTraceLog(traceLogData));
        } catch (error) {
            console.error('Error posting trace logs:', error);
        }
    };
};

export { traceLogReducer, postTraceLog };
